import React from 'react';

const HomeHero = ({ onNavigate }) => {
  return (
    <section className="relative bg-black text-white py-20 md:py-32 lg:py-48 flex items-center justify-center min-h-screen">
      <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: 'url(hero-image.jpg)' }}></div>
      <div className="container mx-auto px-4 text-center relative z-10">
        
        {/* Título principal - Fuente responsiva que disminuye en móvil SIN SCROLL */}
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-extrabold leading-tight mb-6 animate-fade-in-up">
          Consultores Evelio Bustos Apache SAS
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-10 max-w-3xl mx-auto animate-fade-in-up animation-delay-300 text-white">
          Su socio estratégico en contaduría para el éxito financiero.
        </p>
        
        <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-14 max-w-3xl mx-auto animate-fade-in-up animation-delay-200" style={{ color: '#E8B00C' }}>
          Ética, Calidad y Compromiso.
        </p>

        <button
          onClick={() => onNavigate('contacto')}
          className="px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold shadow-lg transition-all duration-300 transform hover:scale-105 animate-fade-in-up animation-delay-400"
          style={{ backgroundColor: '#E8B00C', color: '#211F1F' }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#c49a0a'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#E8B00C'}
        >
          Agenda una Consulta
        </button>
      </div>
    </section>
  );
};

export default HomeHero;